export const TICKET_STATUS_LABELS = {
  open:        "Ouvert",
  in_progress: "En cours",
  closed:      "Clôturé",
  approved:    "Approuvé",
};

// ID du mode de facturation "Contrat de maintenance" en base
export const MAINTENANCE_BILLING_ID = 1;

/**
 * Retourne la variante Bootstrap Badge pour un statut de ticket.
 * Pour "closed", la couleur dépend du mode de facturation :
 *   - contrat maintenance (ID 1) → success (vert) : clôture normale et attendue
 *   - autre → primary (bleu) : clôture à surveiller (facturation, suivi)
 */
export function getStatusVariant(rawStatus, billingMethodId = null) {
  switch (rawStatus) {
    case "open":        return "danger";
    case "in_progress": return "warning";
    case "closed":
      return Number(billingMethodId) === MAINTENANCE_BILLING_ID ? "success" : "primary";
    case "approved":    return "secondary";
    default:            return "secondary";
  }
}

/** warning a un fond clair — le texte doit être sombre pour la lisibilité */
export function statusNeedsDarkText(variant) {
  return variant === "warning";
}
